// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._5ral1f51{object-fit:contain}
._bfhku67f{background-color:#fff}
._c71l1osq{max-height:100%}
._p12f1osq{max-width:100%}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/media-card/dist/esm/card/svgView/svgImage-compiled.compiled.css"],"names":[],"mappings":"AAAA,WAAW,kBAAkB;AAC7B,WAAW,qBAAqB;AAChC,WAAW,eAAe;AAC1B,WAAW,cAAc","sourcesContent":["._5ral1f51{object-fit:contain}\n._bfhku67f{background-color:#fff}\n._c71l1osq{max-height:100%}\n._p12f1osq{max-width:100%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
